import "../../assets/css/common/common.scss";
import { Select } from "antd";

const CustomSelect = ({ options }) => {

  return (
    <Select
      size={"large"}
      onChange={() => {}}
      style={{ width: "100%" }}
      options={options}
    />
  );
};

export default CustomSelect;
